<script lang="ts">
	import Image from './image.svelte'
	import { format_date } from 'kitto'
	import Link from '#components/link.svelte'
	import type { StoryblokAsset } from '#library/components.schema.build.ts'

	interface Props {
		theme?: string
		image?: StoryblokAsset
		dates?: Array<{ start: string; end: string }>
		price?: string
		event?: string
		href?: string
	}

	let { theme = 'theme-crocus-on-light-gimson', image, dates, price, event, href }: Props = $props()
</script>

<div class="calendar {theme}">
	{#if image?.filename}
		<div class="cell">
			<Image src={image.filename} alt={image.alt} focus={image.focus} aspect="1/1" fill />
		</div>
	{/if}
	<div class="cell">
		{#if dates?.length && dates[0]?.start && dates[0]?.end}
			{#each dates as date, i (i)}
				{@const [start_date, start_time] = date.start?.split(' ') ?? []}
				{@const [end_date, end_time] = date.end?.split(' ') ?? []}
				<div class="date">
					<div class="day">
						{#if start_date === end_date}
							{format_date('{ddd}, {MMM} {D} {YYYY}', start_date)}
						{:else}
							{format_date('{ddd}, {MMM} {D} {YYYY}', start_date)} to {format_date(
								'{ddd}, {MMM} {D} {YYYY}',
								end_date
							)}
						{/if}
					</div>
					<div class="time">
						{#if start_time === end_time}
							{start_time}
						{:else}
							{[start_time, end_time].filter(Boolean).join(' - ')}
						{/if}
					</div>
				</div>
			{/each}
		{/if}
	</div>
	{#if price}
		<div class="cell">
			<div>{price}</div>
		</div>
	{/if}
	<div class="cell fill">
		<div>{event}</div>
	</div>
	{#if href}
		<div class="cell">
			<Link {href} target="_blank" text="See details" />
		</div>
	{/if}
</div>

<style lang="css">
	.calendar {
		background-color: var(--c-background);
		border: 1px solid var(--c-gimson);
		border-block-end: none;
		color: var(--c-midground);

		@media (--from-mobile) {
			display: flex;
		}

		&:last-child {
			border-block-end: 1px solid var(--c-gimson);
		}
	}

	.cell {
		display: flex;
		flex: 1 0 auto;
		flex-direction: column;
		padding: 1.25rem 1.5rem;

		@media (--from-mobile) {
			align-items: center;
			justify-content: center;
			width: 0%;

			&.fill {
				flex-grow: 2;
			}
		}

		:global(.link) {
			--c-foreground: var(--c-midground);
			width: 100%;
		}

		& + .cell {
			border-inline-start: 1px solid var(--c-gimson);
		}
	}

	.date {
		@media (--from-mobile) {
			text-align: center;
		}
	}

	.day {
		font: 500 var(--f-body1);
		text-wrap: balance;
	}

	.time {
		font: 400 var(--f-body2);
	}
</style>
